import { useEffect } from "react";
import { toast } from "sonner";

const MAIN_RE = /\/static\/js\/main\.[a-f0-9]+\.js/;

const currentBundle = () => {
  const s = Array.from(document.scripts).find((el) => MAIN_RE.test(el.src));
  return s ? s.src.match(MAIN_RE)[0] : null;
};

export const UpdateChecker = () => {
  useEffect(() => {
    const loaded = currentBundle();
    if (!loaded) return undefined;
    let notified = false;

    const check = async () => {
      if (notified || document.visibilityState !== "visible") return;
      try {
        const res = await fetch(`/?v=${Date.now()}`, { cache: "no-store" });
        const latest = (await res.text()).match(MAIN_RE)?.[0];
        if (latest && latest !== loaded) {
          notified = true;
          const busy = Array.from(document.querySelectorAll("input, textarea")).some((el) => el.type !== "hidden" && el.value)
            || !!document.querySelector('[data-testid^="deposit-summary-line-"]');
          toast.info("Nouvelle version disponible", {
            description: busy ? "Cliquez sur « Mettre à jour » quand vous avez terminé." : "La page va se mettre à jour...",
            duration: busy ? Infinity : 10000,
            action: { label: "Mettre à jour", onClick: () => window.location.reload() },
          });
          if (!busy) setTimeout(() => window.location.reload(), 5000);
        }
      } catch (e) {
        // offline: retry later
      }
    };

    const timer = setInterval(check, 60000);
    document.addEventListener("visibilitychange", check);
    window.addEventListener("focus", check);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", check);
      window.removeEventListener("focus", check);
    };
  }, []);

  return null;
};
